/**
 * Spell check color constants
 * These colors should match the SCSS variables in spellcheck.scss
 */
export const SPELLCHECK_COLORS = {
  FIXABLE: '#ff0000', // Red for errors with fixes
  INFORMATIONAL: '#ffa500', // Orange for warnings/informational
};
